<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ 'PR.PR_INFO' | translate }}</h3>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <dl class="row">
      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.CODE' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ practitionRole.code }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.STATUS' | translate }}</dt>
      <dd class="col-sm-9 py-2">
        <span
          class="label label-lg label-light-{{
            getItemCssClassByStatus(practitionRole.active)
          }} label-inline"
          >{{ getItemStatusString(practitionRole.active) }}</span
        >
      </dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.PERIOD_START' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ practitionRole.period_start }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.PERIOD_END' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ practitionRole.period_end }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.SPECIALTY' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ getSpecialty(practitionRole.specialty) }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.NOT_AVAILABLE_DESC' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ getDescNotAvailable(practitionRole.notAvailable) }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.NOT_AVAILABLE_START' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ getStartNotAvailable(practitionRole.notAvailable) }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.NOT_AVAILABLE_END' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ getEndNotAvailable(practitionRole.notAvailable) }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.AVAILABLE_EXCEPTIONS' | translate }}</dt>
      <dd class="col-sm-9 py-2">{{ practitionRole.availabilityExceptions }}</dd>

      <dt class="col-sm-3 py-2">{{ 'PR.INPUT.AVAILABILITY' | translate }}</dt>
      <dd class="col-sm-9 py-2">
        <ul>
          <li *ngFor="let ava of availability">{{ ava }}</li>
        </ul>
      </dd>
    </dl>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>{{ 'TABLE.CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
